import axiosRepdPublic from 'Axios';

// Peticion para cuando se inicia sesion solamente
export const testConnection = (credentials) => 
    axiosRepdPublic.post('auth/token/obtain/', credentials)